export const ORGANIZATIONS = {
  AO_SMITH: 'ao-smith',
};
